import {RootState} from "src/store/rootReducer"
import {getAuthAPI} from "../../../scholastic-client-components/src/api/authAPI"

export const authAPI = getAuthAPI<RootState>()
